import { useForm } from '@inertiajs/react'
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Agent } from '@/types/serializers'

interface Props {
  agent?: Agent;
  [key: string]: any;
}

export default function Form({ agent }: Props) {
  const { data, setData, post, put, processing, errors } = useForm({
    name: agent?.name || '',
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (agent?.id) {
      put(`/agents/${agent.id}`)
    } else {
      post('/agents')
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="name">Name</Label>
        <Input
          id="name"
          value={data.name}
          onChange={e => setData('name', e.target.value)}
          disabled={processing}
        />
        {errors.name && (
          <p className="text-sm text-destructive">{errors.name}</p>
        )}
      </div>

      <div className="flex justify-end">
        <Button type="submit" disabled={processing}>
          {agent?.id ? 'Update Agent' : 'Create Agent'}
        </Button>
      </div>
    </form>
  )
}
